import Vue from "vue";
import Router from "vue-router";
import store from "@/store";
import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default.css'

import LoginView from "@/components/view/LoginView";
import OrderView from "@/components/view/OrderView";
import ProfileView from "@/components/view/ProfileView";
import ResetPasswordView from "@/components/view/ResetPasswordView";
import ForgotPasswordView from "@/components/view/ForgotPasswordView";
import moment from "moment";

Vue.use(Router);
Vue.use(VueMaterial);

let router = new Router({
    mode: 'history',
    routes: [

        {path: '/', redirect: '/all_orders'},
        {
            path: "/all_orders",
            name: "orders",
            component: OrderView,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: "/open_orders",
            name: "open_orders",
            component: OrderView,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: "/login",
            name: "login",
            component: LoginView,
        },
        {
            path: "/password_reset",
            name: "password_reset",
            component: ResetPasswordView,
        },
        {
            path: "/forgot_password",
            name: "forgot_password",
            component: ForgotPasswordView,
        },
        {
            path: "/profile",
            name: "profile",
            component: ProfileView,
            meta: {
                requiresAuth: true
            }
        },
    ],
});

router.beforeEach(async(to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (store.getters["auth/isLoggedIn"] && moment(store.getters["auth/expiraton_time"], "YYYY-M-D H:m").diff(moment(), 'minutes') >= 0) {
            next();
            return
        }
        await store.dispatch('auth/logout')
        next({
            path: '/login',
            query: {redirect: to.fullPath}
        })
    } else {
        next();
    }
})

export default router;